module.exports = __webpack_public_path__ + "static/yuyud-100892787b069adbbbf461c35015bcc2.jpg";